// extracted by mini-css-extract-plugin
export default {"nav-logo":"Contact_nav-logo__Zo6Rh","btn":"Contact_btn__xlWwX","section":"Contact_section__TLIx5","inputone":"Contact_inputone__9IT6P","inputtwo":"Contact_inputtwo__aseAu"};